export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_7.9aeb96b8.png";